export default "__VITE_ASSET__C95s$S1A__"